<template>
  <div @click="goBackButton()">
    <slot>button</slot>
  </div>
</template>

<script>
export default {
  name: 'backbuttonpanel',
  data() {
    return {
      active: false,
    };
  },
  methods: {
    goBackButton() {
      if (window.eventBus) {
        window.eventBus.$emit('update.itemmegamenu', false);
      }
    },
  },
};
</script>
